import { FileUp, Keyboard, Link2, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import useTranslation from "../../client/hooks/useTranslation";
import { Button } from "../../client/components/ui/button";
import { useLiteActions } from "../shell/LiteActions";
import { cardCls } from "../ui/ui";

/** Écran vide : explique ce qui apparaîtra ici et propose le premier pas. */
export function EmptyStart({ icon: Icon, title, text, cta }: { icon: LucideIcon; title: string; text: string; cta?: ReactNode }) {
  const t = useTranslation().lite.onboarding.empty;
  const { openConnectBroker, openImportCsv, openAddTrade } = useLiteActions();
  return (
    <section className={`${cardCls} px-6 py-14 md:py-20 text-center`}>
      <span className="w-12 h-12 rounded-2xl bg-primary/15 text-primary grid place-items-center mx-auto"><Icon size={22} /></span>
      <h2 className="font-display text-xl font-bold mt-4">{title}</h2>
      <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">{text}</p>
      <div className="flex flex-wrap justify-center gap-2 mt-6">
        {cta ?? (
          <>
            <Button onClick={openConnectBroker}><Link2 className="h-4 w-4 mr-1.5" />{t.connectBroker}</Button>
            <Button variant="outline" onClick={openImportCsv}><FileUp className="h-4 w-4 mr-1.5" />{t.importFile}</Button>
            <Button variant="ghost" onClick={openAddTrade}><Keyboard className="h-4 w-4 mr-1.5" />{t.manualTrade}</Button>
          </>
        )}
      </div>
    </section>
  );
}
